import {
  IOperatorPilotState,
  actionTypes,
} from 'src/ducks/operator-pilot.duck';
import { IStatus } from 'src/libraries/thunk.library';

export const getOperatorPilotStatus = (
  state: IOperatorPilotState,
  action: keyof typeof actionTypes
): IStatus =>
  state.status[action] ?? {
    fetching: false,
    error: null,
  };
